__turbopack_context__.v({
  "className": "fraunces_dd24e94c-module__VRe69q__className",
  "variable": "fraunces_dd24e94c-module__VRe69q__variable",
});
